import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { MemberCardBarcodesImagesEffects } from './member-card-barcodes-images.effects';
import { memberCardBarcodesImagesReducer } from './member-card-barcodes-images.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('memberCardBarcodesImages', memberCardBarcodesImagesReducer), EffectsModule.forFeature([MemberCardBarcodesImagesEffects])],
    exports: [],
    providers: [],
})
export class MemberCardBarcodesImagesStateModule {}
